const generateDates = startDateStr => {
  //console.log("startDateStr:", startDateStr);

  let startDate = new Date(startDateStr);
  //console.log("Formatted startDateStr (UTC):", startDate.toISOString());

  const options = { year: 'numeric', month: 'short', timeZone: 'UTC' };
  let datesArray = [];

  for (let i = 0; i < 12; i++) {
    let formattedDate = startDate.toLocaleDateString('en-US', options);
    datesArray.push(formattedDate);

    startDate.setUTCMonth(startDate.getUTCMonth() + 1);
    startDate.setUTCDate(1);
  }

  return datesArray;
};

export default generateDates;
